import {useSignFn} from "../../../utils/sign_fn";
import {useWallet} from "use-wallet";
import {useCallback} from "react";
import {HttpServer} from "../../../net/http_server";
import {AppConfig} from "../../../config";
import {useWeb3} from "../../../provider/web3_provider";
import {useClaim} from "../../../web3/use_fn/capita_stake";


export const useRewards = () => {
    const sign = useSignFn();
    const {account} = useWallet();
    const {contrcts} = useWeb3();
    const  [handleClaim] = useClaim();
    const fatch = useCallback(async (amount:string,currency:number)=>{

        let nonce = await contrcts.stakeContract.methods.nonces(account).call();
        let _params = rewardsJson({
            account: account,
            currency: currency.toString(2),
            amount: amount,
            nonce,
        });
        let _sign = await sign(_params);
        let _data = await HttpServer.withdraw(_sign,_params);
        let _hax = handleClaim({..._data,currency,amount})
        return _hax;
    },[account]);

    return fatch;
}


/**
  account: account,
 currency: currency,
 amount: amount,
 nonce: nonce,
 * @param data
 */
const rewardsJson = (data:any): string => {

    let method = "withdraw";

    return JSON.stringify({
        domain: {
            name: method,
            chainId: AppConfig.chainId.toString(),
        },
        message: {
            method: method,
            content: {
                ...data,

            }
        },
        primaryType: 'Place',
        types: {
            EIP712Domain: [
                {name: 'name', type: 'string'},
                {name: 'chainId', type: 'uint256'},
            ],
            Place: [
                {name: 'content', type: 'Model'},
                {name: 'method', type: 'string'},
            ],
            Model: [
                {name: 'account', type: 'string'},
                {name: 'currency', type: 'string'},
                {name: 'amount', type: 'string'},
                {name: 'nonce', type: 'string'},
            ],

        }
    });
}
